// extracted by mini-css-extract-plugin
module.exports = {"left":"styles_left__bfMwu","stepsCounter":"styles_stepsCounter__5VPVM"};